import { useATTrackInteraction } from '@at/consumer-web-snowplow'
import { SearchResultsListingsGridQuery_searchResults_SearchResults_listings_SearchListing_trackingContext_TrackingContext } from '../contexts/search-results-context/query/__generated__/search-results-listings.fed.query'
import { calculateGridPosition } from '../utils/tracking/grid-position'
import { getCommonComponentContexts, TrackingContext } from '../utils/tracking/tracking'
import { setSearchJourneyCookie } from '../utils/cookie'
import { LAST_VIEWED_ADVERT_ID, setItemSessionStorage } from '@at/window-utils'
import { ListingType } from '../__generated__/fed-graphql-types'

export const useJourneyDataBuilder = ({
    trackingContext,
    ref,
    type,
    advertId,
}: {
    trackingContext?: SearchResultsListingsGridQuery_searchResults_SearchResults_listings_SearchListing_trackingContext_TrackingContext
    ref?: HTMLDivElement
    type?: ListingType
    advertId: string
}) => {
    const commonComponentContexts = getCommonComponentContexts({
        ...trackingContext,
        gridPosition: calculateGridPosition(ref, trackingContext?.card.position),
    } as TrackingContext)
    const handleTrackingInteraction = useATTrackInteraction()
    const journeyDataBuilder = () => {
        handleTrackingInteraction({
            trackingLabel: 'results-nav-fpa',
            customiseEntities: (entities) => [...entities, ...commonComponentContexts],
        })
        setSearchJourneyCookie(type, advertId)
        setItemSessionStorage(LAST_VIEWED_ADVERT_ID, advertId)
    }

    return { journeyDataBuilder }
}
